export default class OurWorkTiles {

	constructor(element) {
		const videos = [];
		element.querySelectorAll('article .image').forEach(tile => {
			const video = tile.querySelector('video');
			const image = tile.querySelector('.cover-image');
			if (!video) {
				return;
			}
			videos.push(video);
			tile.addEventListener('mouseover', () => {
				image.classList.add('hover');
				video.play();
			});
			tile.addEventListener('mouseout', () => {
				image.classList.remove('hover');
				video.pause();
			})
		});

		const observer = new IntersectionObserver((entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) {
					return;
				}
				for (const source of entry.target.querySelectorAll('source[data-src]')) {
					source.src = source.dataset.src;
					delete source.dataset.src;
				}
				entry.target.load();
				observer.unobserve(entry.target);
			}
		}, {rootMargin: '200px'});
		videos.forEach(v => observer.observe(v));



		const filterLabelsSelect = document.getElementById('filter-labels');
		if (filterLabelsSelect) {
			filterLabelsSelect.addEventListener("change", (event) => {
				const value = event.target.value.toLowerCase();
				const isFiltered  = value !== "all";
				const articles = element.querySelectorAll('article');
				articles.forEach(article => {
					if (isFiltered) {
						const labels = article.dataset.labels.split(",").map(l => l.trim().toLowerCase());
						article.hidden = !labels.includes(value);
					} else {
						article.hidden = false;
					}
				});
			});
		}
	}

}
